// Global Turbolinks navigation loading feedback & double-click prevention
document.addEventListener('turbolinks:click', function(e) {
  if (document.body.classList.contains('turbolinks-nav-pending')) {
    e.preventDefault();
    return false;
  }
});

document.addEventListener('turbolinks:request-start', function() {
  document.body.classList.add('turbolinks-nav-pending');
  $('.modal-photo').show();
  $('.sidenav, .navbar, .menu-components').css('pointer-events', 'none');
});

document.addEventListener('turbolinks:request-end', function() {
  document.body.classList.remove('turbolinks-nav-pending');
  $('.modal-photo').hide();
  $('.sidenav, .navbar, .menu-components').css('pointer-events', '');
});

window.addEventListener('turbolinks:load', () => {
  document.body.classList.remove('turbolinks-nav-pending');
  $('.modal-photo').hide();
  $('.sidenav, .navbar, .menu-components').css('pointer-events', '');

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const ref = urlParams.get('ref')
  if(ref != null){
    document.cookie = "ref=" + ref + ";domain=.sendfy.app;path=/";
  }
  $('.select-groups').select2({
    closeOnSelect: false
  });
  $('.select').select2({
    templateResult: hideSelected,
  });
  $('.select-webhook-notifications').select2();
  $('.select-tags').select2({
    tags: true,
    tokenSeparators: [",",";"," "]
  });
  $('.select-tags-clear').select2({
    tags: true,
    allowClear: true,
    placeholder: '',
  });
  $('.select-tags-agent').select2({
    tags: true,
    maximumSelectionLength: 1
  });
  $('.select-whatsapp-redirect').select2({
    tags: true
  });
  $(document).off('submit', 'form').on('submit', 'form', function(e){
    if (e.isDefaultPrevented() || $(this).hasClass('no-loading')) return;
    $('.modal-photo').show();
    const selectFields = document.querySelectorAll('select.select');
    selectFields.forEach(field => {
      const form = field.closest('form');
      if (form) {
        const selectedOptions = field.selectedOptions;
        if (selectedOptions.length === 0) {
          const hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = field.name;
          hiddenInput.value = '';
          form.appendChild(hiddenInput);
        }
      }
    });
  });

  $(document).off('ajax:send', 'form').on('ajax:send', 'form', function(){
    $('.modal-photo').show();
  });

  $(document).off('ajax:complete', 'form').on('ajax:complete', 'form', function(){
    $('.modal-photo').hide();
  });
  const phoneInputField = document.querySelector(".phone");
  if (phoneInputField) {
    const phoneInput = window.intlTelInput(phoneInputField, {
      initialCountry: 'br',
      hiddenInput: "phone",
      nationalMode: true,
      placeholderNumberType: "MOBILE",
      separateDialCode: true,
        utilsScript:
          "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
      });
  }
  var coll = document.getElementsByClassName("collapsible");
  var i;
  for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      if (content.style.display === "block") {
        content.style.display = "none";
      } else {
        content.style.display = "block";
      }
    });
  }
  $(".youtube-video").click(function () {
    let theModal = $(this).data("target"),
    videoSRC = $(this).attr("data-video"),
    videoSRCauto = videoSRC + "?modestbranding=1&rel=0&controls=1&showinfo=0&html5=1&autoplay=1";
    $(theModal + ' iframe').attr('src', videoSRCauto);
    $(theModal).on('hidden.bs.modal', function (e) {
      $(theModal + ' iframe').attr('src', '');
    })
  });
  if($("#first_login").val() == "true"){
    const driver = window.driver;
    const driverObj = driver({
      steps: [
        { element: '#tour', popover: { title: 'Inicie o tour por aqui', description: 'Entenda como a plataforma funciona.', side: "left", align: 'start' }},
        { element: '.menu-components', popover: { title: 'Navegue entre os menus', description: 'Suas funcionalidades do sistema.', side: "rigth", align: 'start' }},
        { element: '.help-button', popover: { title: 'Canal de ajuda', description: 'Temos vídeos ensinando cada funcionalidade.', side: "rigth", align: 'start' }},
        { element: '.cc-15e7', popover: { title: 'Suporte', description: 'Estamos sempre aqui para ajudar.', side: "top", align: 'start' }},
        { popover: { title: 'Isso é tudo', description: 'Qualquer dúvida ou sugestão, pode nos chamar.' } }
      ]
    });
    driverObj.drive();
    $.post("/update_user_first_login", function(data, status){})
  }
  $(".prompt_btn1").click(function () {
    $("#call_agent_prompt").html("")
    $("#call_agent_prompt").append("Se apresente como Maria e pergunte gentilmente como esta sendo o dia da pessoa que atender." +
      "\n\n" +
      "Você vende um curso online de cuidador de idosos feito por Angelica Pimenta." +
      "\n\n" +
      "Pergunte se a pessoa tem interesse em trabalhar como cuidador de idosos, se ela não tiver interesse agradeça e desligue a ligação." +
      "\n\n" +
      "Se ela tiver interesse em trabalhar, explique mais detalhes sobre o curso" +
      "\n\n" +
      "O curso tem o investimento de R$ 97 reais podendo parcelar no cartão de crédito em até 12 vezes, o curso é valido pelo MÉC do Brasil, isso é um benefício e traz qualidade no curso." +
      "\n\n" +
      "O curso é totalmente online, tem 25 aulas já gravadas e assim que o aluno terminar de assistir todas as aulas ele ja pode emitir o certificado de forma online." +
      "\n\n" +
      "Caso a pessoa tenha interesse no curso, diga o site angelicapimenta.com e la ela faz o pagamento e vai receber todos os detalhes por email."
    )
  });
  $(".prompt_btn2").click(function () {
    $("#call_agent_prompt").html("")
    $("#call_agent_prompt").append("Se apresente como Maria e pergunte gentilmente como esta sendo o dia da pessoa que atender." +
      "\n\n" +
      "Você é dona de uma agência de marketing digital e quer oferecer serviços como tráfego pago, automação, página de vendas." +
      "\n\n" +
      "Pergunte se a pessoa tem interesse em ter mais visibilidade e mais vendas pois é isso que uma agência de marketing digital pode ajudar." +
      "\n\n" +
      "Se ela tiver interesse em trabalhar com você, diga a ela que você irá chamar ela no Whatsapp e passasr o link para agendarmos uma reunião e você apresentar uma proposta." +
      "\n\n" +
      "Qualquer outra dúvida ou assunto ela pode acessar o site agencianow.com"
    )
  });
  var playing = false;
  jQuery("#audio-button").click(function() {
    jQuery(this).toggleClass("down");
    if (playing == false) {
      document.getElementById("player").play();
      playing = true;
      jQuery(this).html("<i class='fa fa-stop' aria-hidden='true'></i>");
    } else {
      document.getElementById("player").pause();
      playing = false;
      jQuery(this).html("<i class='fa fa-play' aria-hidden='true'></i>");
    }
  });
  var currentAudio = document.getElementById('audio-player');
  var currentlyPlaying = null;
  var audioCache = {}; // Cache para armazenar áudios já carregados

  $('.play-audio').click(function(e) {
    e.preventDefault();

    var audioId = $(this).attr('id');
    var audioElement = $(this);

    // Controle de play/pause para o mesmo áudio
    if (currentAudio && currentlyPlaying === audioId) {
      if (!currentAudio.paused) {
        currentAudio.pause();
        currentlyPlaying = null;
        audioElement.removeClass('active');
        return;
      } else {
        currentAudio.play();
        audioElement.addClass('active');
        return;
      }
    }

    // Para o áudio atual
    if (currentAudio && currentlyPlaying !== null) {
      currentAudio.pause();
      $('.play-audio').removeClass('active');
    }

    // Verifica se já temos no cache
    if (audioCache[audioId]) {
      playFromCache(audioId, audioElement);
      return;
    }

    // Busca o áudio em Base64
    fetchAudioBase64(audioId, audioElement);
  });

  function playFromCache(audioId, element) {
    currentAudio.src = audioCache[audioId];
    currentAudio.play();
    currentlyPlaying = audioId;
    element.addClass('active');
    $('#audio-player').show();
  }

  function fetchAudioBase64(audioId, element) {
    $.ajax({
      url: '/get_voices_audio?voice_id=' + audioId,
      method: 'GET',
      dataType: 'json',
      success: function(response) {
        if (response.base64) {
          // Formata o Base64 corretamente
          var audioSrc = `data:audio/mpeg;base64,${response.base64}`;

          // Armazena no cache
          audioCache[audioId] = audioSrc;

          // Reproduz o áudio
          playFromCache(audioId, element);
        } else {
          console.error('Dados de áudio não recebidos');
        }
      },
      error: function(xhr, status, error) {
        console.error('Erro ao carregar áudio:', error);
        alert('Erro ao carregar o áudio. Tente novamente.');
      }
    });
  }

  if(currentAudio){
    currentAudio.addEventListener('ended', function() {
      currentlyPlaying = null;
      $('.play-audio').removeClass('active');
    });
  }
})

function hideSelected(value) {
  if (value && !value.selected) {
    return $('<span>' + value.text + '</span>');
  }
}

// -------------------------------------------------------------
// Custom Desktop Sidenav Toggler (Bypasses argon.js conflicts)
// -------------------------------------------------------------

// Restore saved state purely for desktop (width >= 1200) on page load
$(document).on('turbolinks:load', function() {
  var $body = $('body');
  var stateKey = 'sendfy-desktop-sidenav';

  if ($(window).width() >= 1200) {
    var savedState = localStorage.getItem(stateKey);
    // Alterado: Por padrao (null) inicia fechado, a menos que esteja explicitamente "pinned"
    if (savedState !== 'pinned') {
      $body.removeClass('g-sidenav-show g-sidenav-pinned').addClass('g-sidenav-hidden');
    } else {
      $body.removeClass('g-sidenav-hidden').addClass('g-sidenav-show g-sidenav-pinned');
    }
  }
});

// Handle clicking the custom toggle button in the top navbar (Delagated to document)
$(document).on('click', '.desktop-sidenav-toggler', function(e) {
  e.preventDefault();
  var $body = $('body');
  var stateKey = 'sendfy-desktop-sidenav';

  if ($body.hasClass('g-sidenav-hidden')) {
    // Expand
    $body.removeClass('g-sidenav-hidden').addClass('g-sidenav-show g-sidenav-pinned');
    localStorage.setItem(stateKey, 'pinned');
  } else {
    // Collapse
    $body.removeClass('g-sidenav-show g-sidenav-pinned').addClass('g-sidenav-hidden');
    localStorage.setItem(stateKey, 'hidden');
  }
});
